
export const budgetbasic = {

  budgetcycle: {
    service: {
      name: 'budgetcycle',
      title: 'Budget Cycle',
    }
  },

  budgetstate: {
    service:{
      name:'budgetstate',
      title:'Budget State',
    }
  },

  investmenttype: {
    service:{
      name:'investmenttype',
      title:'Investment Type',
    }
  },

  investmentstate: {
    service:{
      name:'investmentstate',
      title:'Investment State',
    }
  },
  budgetexecutionstate: {
    service:{
      name:'budgetexecutionstate',
      title:'Budget Execution State',
    }
  },

  budgetexecutiontype: {
    service:{
      name:'budgetexecutiontype',
      title:'Budget Execution Type',
    }
  },

  budgettype: {
    service:{
      name:'budgettype',
      title:'Budget Type', 
    }
  },

  budgetscenario: {
    service:{
      name:'budgetscenario',
      title:'Budget Scenario', 
    }
  },

  executionnature: {
    service:{
      name:'executionnature',
      title:'Execution Nature', 
    }
  },

  executionsource: {
    service:{
      name:'executionsource',
      title:'Execution Source', 
    }
  },

  lineitemstate: {
    service:{
      name:'lineitemstate',
      title:'Lineitem State', 
    }
  },

  lineitemtype: {
    service:{
      name:'lineitemtype',
      title:'Line Item Type', 

    }
  },

  transactionstate: {
    service:{
      name:'transactionstate',
      title:'Transaction State',
    }
  },

  transactiontype: {
    service:{
      name:'transactiontype',
      title:'Transaction Type',
    }
  },

};
